/**
 * Optical logo sizes for the ReHub ecosystem cards.
 *
 * Source files mix tight wordmarks, padded canvases and a stacked square
 * (Screen Record). A single h-8 / max-w-[140px] makes some marks shout and
 * others disappear. These classes keep the ink at a similar visual weight.
 */

const ECOSYSTEM_LOGO_CLASS: Record<string, string> = {
  photoedit: 'h-8 max-w-[10.5rem]',
  hdrphoto: 'h-11 max-w-[8rem]',
  photoclear: 'h-9 max-w-[16rem] scale-[1.4145]',
  virtualstaging: 'h-9 max-w-[11.5rem]',
  imagemotion: 'h-7 max-w-[10.8rem] scale-[0.72]',
  videomotion: 'h-11 max-w-[12.65rem] scale-[1.1]',
  propertycut: 'h-10 max-w-[12.1rem] scale-[1.1]',
  hyperdusk: 'h-11 max-w-[10.2rem] scale-[0.95]',
  screenrecord: 'h-16 w-auto max-h-16 max-w-[7.5rem]',
  '360tours': 'h-16 max-w-[13rem]',
  planos: 'h-10 max-w-[9.25rem]',
  sketchplan: 'h-8 max-w-[11.5rem]',
};

export const ECOSYSTEM_LOGO_SLOT_CLASS =
  'flex h-16 min-w-0 flex-1 items-center overflow-visible';

function normalizeEcosystemName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '')
    .replace(/(studio|ai)$/g, '');
}

export function ecosystemLogoClass(name: string): string {
  const key = normalizeEcosystemName(name);
  const size = ECOSYSTEM_LOGO_CLASS[key] ?? 'h-9 max-w-[11rem]';
  return `w-auto origin-left object-contain object-left ${size}`;
}
